export function MatchScore({ score, size = "md" }) {
  const color = score >= 85 ? "#059669" : score >= 65 ? "#D96B27" : "#64748B";
  const dims = size === "lg" ? 80 : size === "sm" ? 44 : 60;
  const stroke = size === "lg" ? 7 : 5;
  const r = (dims - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: dims, height: dims }} data-testid={`match-score-${score}`}>
      <svg width={dims} height={dims} className="-rotate-90">
        <circle cx={dims / 2} cy={dims / 2} r={r} stroke="#E2E8F0" strokeWidth={stroke} fill="none" />
        <circle cx={dims / 2} cy={dims / 2} r={r} stroke={color} strokeWidth={stroke} fill="none"
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round" style={{ transition: "stroke-dashoffset 0.6s ease" }} />
      </svg>
      <span className="absolute font-mono-tech font-bold" style={{ color, fontSize: size === "lg" ? 18 : size === "sm" ? 11 : 14 }}>{score}%</span>
    </div>
  );
}

export function MatchBadge({ band }) {
  const map = {
    "Excellent Match": "bg-emerald-100 text-emerald-700",
    "Good Match": "bg-[#FFF3EC] text-[#C05615]",
    "Potential Match": "bg-slate-100 text-slate-600",
  };
  return <span className={`text-xs font-semibold px-2 py-0.5 rounded ${map[band] || map["Potential Match"]}`}>{band}</span>;
}
